export default "__VITE_ASSET__CaAiiHsf__"